import React, { ChangeEvent, FormEvent, useContext, useState } from "react";
import { Store } from "../../context/Store";

import ChatIcon from "../../assets/Images/Mobile/ChatIcon.png";
import MicIcon from "../../assets/Images/Mobile/MicIcon.png";
import CameraIcon from "../../assets/Images/Mobile/CameraIcon.png";
import SendInputIcon from "../../assets/Images/Mobile/SendInputIcon.png";
import DisabledSendInputIcon from "../../assets/Images/Mobile/DisabledSendInputIcon.png";
import SkipIcon from "../../assets/Images/Mobile/SkipIcon.png";

import {
  ButtonsBox,
  MuteButton,
  OpenChatDiv,
  ChatButton,
  ChatInput,
  SendChatButton,
  VideoButton,
  MicandInputDiv,
} from "./PersonaVideoButtonsStyles";
/**
 *
 * @returns Buttons to be attached to bottom of PersonVideo
 */
const PersonVideoButton: React.FC = () => {
  const { state, dispatch } = useContext(Store);
  const {
    mute,
    scene,
    intermediateUserUtterance,
    persona,
    conversationTranscript,
  } = state;

  const [inputValue, setInputValue] = useState("");
  const [videoOn, setVideoOn] = useState(scene?.isCameraActive());
  const [micOn, setMicOn] = useState(scene?.isMicrophoneConnected());

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };
  // conversationTranscript
  const handleChatSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (inputValue.trim() !== "") {
      // Send message to dp
      persona?.conversationSend(inputValue, {}, {});
      // Add message to transcript
      dispatch({
        type: "ADD_CONVERSATION_MESSAGE",
        payload: {
          source: "user",
          text: inputValue,
        },
      });
      setInputValue("");
    }
  };

  const toggleMute = () => {
    if (micOn) {
      //  mute/unmute user
      mute ? scene?.startRecognize() : scene?.stopRecognize();

      // update state to muted
      dispatch({
        type: "TOGGLE_MUTE",
      });
    } else {
      scene?.setMediaDeviceActive({ microphone: true });
      setMicOn(true);
    }
  };

  const toggleConversationTranscript = () => {
    dispatch({
      type: "TOGGLE_CONVERSATION_TRANSCRIPT",
    });
  };

  const toggleCamera = () => {
    scene?.setMediaDeviceActive({ camera: !videoOn });
    setVideoOn(!videoOn);
  };

  const skipButton = () => {
    dispatch({
      type: "SKIP",
    });
  };

  const renderMuteButton = () => {
    if (!micOn || mute) {
      return (
        <MuteButton
          type="button"
          onClick={toggleMute}
          data-tracking="btn-click:ExperienceMuteMicrophone"
          muted
        >
          <picture>
            <img src={MicIcon} alt="Mute Microphone" />
          </picture>
        </MuteButton>
      );
    }

    return (
      <MuteButton type="button" onClick={toggleMute}>
        <picture>
          <img
            src={MicIcon}
            alt="Unmute Microphone"
            data-tracking="btn-click:ExperienceUnMuteMicrophone"
          />
        </picture>
      </MuteButton>
    );
  };

  const renderChatButton = () => {
    if (!conversationTranscript) {
      return (
        <ChatButton
          type="button"
          onClick={() => toggleConversationTranscript()}
          data-tracking="btn-click:messageIconOff"
          closed
        >
          <img src={ChatIcon} alt="Close Text Input" />
        </ChatButton>
      );
    }

    return (
      <ChatButton
        type="button"
        onClick={() => toggleConversationTranscript()}
        data-tracking="btn-click:messageIconOn"
      >
        <img src={ChatIcon} alt="Open Text Input" />
      </ChatButton>
    );
  };

  const renderChatInput = () => {
    return (
      <OpenChatDiv>
        <form onSubmit={handleChatSubmit}>
          <ChatInput
            type="text"
            placeholder="Enter your response here"
            onChange={handleInput}
            disabled={intermediateUserUtterance !== "" ? true : false}
            value={
              intermediateUserUtterance !== ""
                ? `Norma Heard : "${intermediateUserUtterance}" `
                : inputValue
            }
          />
          <SendChatButton type="submit">
            <img
              src={
                inputValue.length > 0 ? SendInputIcon : DisabledSendInputIcon
              }
              alt="Submit"
            />
          </SendChatButton>
        </form>
      </OpenChatDiv>
    );
  };

  const renderCameraButton = () => {
    if (!videoOn) {
      return (
        <VideoButton
          type="button"
          onClick={() => toggleCamera()}
          data-tracking="btn-click:ExperienceCameraOff"
          off
        >
          <picture>
            <img src={CameraIcon} alt="Turn off video" />
          </picture>
        </VideoButton>
      );
    }

    return (
      <VideoButton
        type="button"
        onClick={() => toggleCamera()}
        data-tracking="btn-click:ExperienceCameraOn"
      >
        <picture>
          <img src={CameraIcon} alt="Turn on video" />
        </picture>
      </VideoButton>
    );
  };
  const renderSkipButton = () => {
    return (
      <VideoButton
        type="button"
        onClick={() => skipButton()}
        data-tracking="btn-click:Skip"
      >
        <picture>
          <img src={SkipIcon} alt="Turn on video" />
        </picture>
      </VideoButton>
    );
  };

  return (
    <ButtonsBox>
      {renderCameraButton()}
      {renderMuteButton()}
      {renderSkipButton()}
      <MicandInputDiv>
        {renderChatButton()}
        {conversationTranscript && renderChatInput()}
      </MicandInputDiv>
    </ButtonsBox>
  );
};

export default PersonVideoButton;
